import { http } from "./http.js";

async function getData(id) {
  const response = await http.get(`customs-entry-registrations/${id}`);
  return response;
}

async function updateRoutePrefix(id, prefix) {
  const response = await http.patch(`routes/${id}/prefix`, {
    value: prefix,
  });
  return response;
}

async function updateRouteDates(id, dates) {
  const response = await http.patch(
    `customs-entry-registrations/${id}/dates`,
    dates,
  );
  return response;
}

async function updateForwarder(id, forwarder) {
  const response = await http.patch(
    `customs-entry-registrations/${id}/forwarder`,
    {
      value: forwarder,
    },
  );
  return response;
}

async function updateExpeditionCost(id, cost) {
  const response = await http.patch(
    `customs-entry-registrations/${id}/expedition-cost`,
    cost,
  );
  return response;
}

async function updateBorderPassCost(id, cost) {
  const response = await http.patch(
    `customs-entry-registrations/${id}/border-pass-cost-${cost.type}`,
    cost,
  );
  return response;
}

async function updateLabel(id, name, value) {
  const response = await http.patch(
    `customs-entry-registrations/${id}/lables/${name}`,
    {
      value,
    },
  );
  return response;
}

async function getItems(id) {
  const response = await http.get(`customs-entry-registrations/${id}/items`);
  return response.data;
}

async function changeExLabel(id, name, value) {
  const response = await http.patch(`shippings/${id}/lables/${name}`, {
    value,
  });
  return response;
}

async function downloadOutputForm(id, resource) {
  const response = await http.get(
    `customs-entry-registrations/${id}/output-xlsx/${resource}`,
    {
      responseType: "arraybuffer",
    },
  );
  return response;
}

async function changeDriver(id, val) {
  const response = await http.patch(`routes/${id}/driver`, {
    value: val,
  });
  return response;
}

async function updateEx(id, ex) {
  const response = await http.patch(`customs-entry-registrations/${id}/ex`, { value: ex });
  return response;
}

async function updateT1(id, t1) {
  const response = await http.patch(`customs-entry-registrations/${id}/t1`, { value: t1 });
  return response;
}

async function updateTir(id, tir) {
  const response = await http.patch(`customs-entry-registrations/${id}/tir`, { value: tir });
  return response;
}

async function updateAdditionalExpenses(id, additionalExpenses) {
  const response = await http.patch(`customs-entry-registrations/${id}/additional-expenses`, { value: additionalExpenses });
  return response;
}

async function changeCustomsManager(id, customsManager) {
  const response = await http.patch(`customs-entry-registrations/${id}/customs-manager`, {
    value: customsManager,
  });
  return response;
}

async function changeNotes(id, notes) {
  const response = await http.patch(`routes/route-items/${id}/notes`, {
    text: notes,
  });
  return response;
}

async function getShippingAttachments(id) {
  const response = await http.get(`shippings/${id}/`);
  return response;
}

export {
  getData,
  updateRoutePrefix,
  updateRouteDates,
  updateForwarder,
  updateExpeditionCost,
  updateBorderPassCost,
  updateLabel,
  getItems,
  changeExLabel,
  downloadOutputForm,
  changeDriver,
  updateEx,
  updateT1,
  updateTir,
  updateAdditionalExpenses,
  changeCustomsManager,
  changeNotes,
  getShippingAttachments,
};
